"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _array = require("@widergy/web-utils/lib/array");

var _FormGroup = _interopRequireDefault(require("@material-ui/core/FormGroup"));

var _FormHelperText = _interopRequireDefault(require("@material-ui/core/FormHelperText"));

var _WithTheme = _interopRequireDefault(require("../WithTheme"));

var _theme = require("./theme");

var _UTCheckRow = _interopRequireDefault(require("./components/UTCheckRow"));

var _stylesModule = _interopRequireDefault(require("./styles.module.scss"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var UTCheckList = /*#__PURE__*/function (_Component) {
  _inherits(UTCheckList, _Component);

  function UTCheckList() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, UTCheckList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(UTCheckList)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      selectAll: false
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      if (_this.props.allChecked) {
        _this.handleCheckAll();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (id) {
      var newValues = _this.props.input.value.indexOf(id) === -1 ? [].concat(_toConsumableArray(_this.props.input.value), [id]) : _this.props.input.value.filter(function (elem) {
        return elem !== id;
      });

      _this.props.input.onChange((0, _array.isEmpty)(newValues) ? null : newValues);

      _this.setState({
        selectAll: newValues && newValues.length === _this.props.list.length
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleCheckAll", function () {
      return _this.setState(function (prevState) {
        if (!prevState.selectAll && _this.props.list) {
          _this.props.input.onChange(_this.props.list.map(function (item) {
            return item[_this.props.valueKey];
          }));
        } else {
          _this.props.input.onChange(null);
        }

        return {
          selectAll: !prevState.selectAll
        };
      });
    });

    return _this;
  }

  _createClass(UTCheckList, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          valueKey = _this$props.valueKey,
          labelKey = _this$props.labelKey,
          input = _this$props.input,
          additionalInfo = _this$props.additionalInfo,
          list = _this$props.list,
          className = _this$props.className,
          shouldShowErrors = _this$props.shouldShowErrors,
          meta = _this$props.meta,
          disabled = _this$props.disabled;
      var selectAll = this.state.selectAll;
      return _react["default"].createElement("div", {
        className: "".concat(_stylesModule["default"].container, " ").concat(className)
      }, _react["default"].createElement(_UTCheckRow["default"], {
        disabled: disabled,
        onChange: this.handleCheckAll,
        checked: selectAll || list.length === input.value.length,
        label: additionalInfo && additionalInfo.header || 'Seleccionar Todo'
      }), _react["default"].createElement(_FormGroup["default"], null, list.map(function (item) {
        return _react["default"].createElement(_UTCheckRow["default"], {
          disabled: disabled,
          key: item[valueKey],
          value: item[valueKey],
          label: item[labelKey],
          checked: input.value.indexOf(item[valueKey]) !== -1,
          onChange: _this2.handleChange
        });
      })), additionalInfo && additionalInfo.footer && _react["default"].createElement(_FormHelperText["default"], null, additionalInfo.footer), shouldShowErrors && _react["default"].createElement(_FormHelperText["default"], {
        error: true
      }, meta && meta.error));
    }
  }]);

  return UTCheckList;
}(_react.Component);

UTCheckList.defaultProps = {
  list: []
};
UTCheckList.propTypes = {
  disabled: _propTypes.bool,
  valueKey: _propTypes.string.isRequired,
  labelKey: _propTypes.string.isRequired,
  input: (0, _propTypes.shape)({
    onChange: _propTypes.func,
    value: _propTypes.any
  }),
  additionalInfo: (0, _propTypes.shape)({
    header: _propTypes.string,
    footer: _propTypes.string
  }),
  list: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    id: _propTypes.number,
    label: _propTypes.string,
    checked: _propTypes.bool
  })),
  allChecked: _propTypes.bool,
  shouldShowErrors: _propTypes.bool,
  className: _propTypes.string,
  meta: _propTypes.any // eslint-disable-line react/forbid-prop-types

};

var _default = (0, _WithTheme["default"])(null, _theme.retrieveMuiTheme)(UTCheckList);

exports["default"] = _default;